<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogReason"
    :append-to-body="true"
    width="800px"
    title="请输入评论内容"
    @close="resetForm('newForm')"
  >
    <el-form
      :model="newForm"
      :rules="rules"
      ref="newForm"
      class="reason-form"
      label-width="130px"
    >
      <el-form-item label="评论内容：" prop="reason">
        <el-input
          type="textarea"
          class="input"
          v-model="newForm.reason"
          maxlength="2000"
          placeholder="请输入评论内容，不得少于50字"
          :rows="5"
        />
      </el-form-item>
      <el-form-item>
        <div class="buttons">
          <el-button type="info" @click="resetForm('newForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('newForm')" :loading="loading">
            确认
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: '',
  props: {
    showReason: {
      type: Boolean,
      default: false,
    },
    items: Object,
  },
  watch: {
    showReason(val) {
      this.dialogReason = val
    },
  },
  data() {
    return {
      loading: false,
      dialogReason: false,
      newForm: {},
      rules: {
        reason: [{ required: true, validator: this.validateReason, trigger: 'blur' }],
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.checkWord()
        } else {
          return false
        }
      })
    },
    checkWord() {
      let body = { reason: this.newForm.reason }
      this.$http({
        url: `/api/v1/platform/libinfoBadword/review`,
        method: 'POST',
        data: body,
      }).then(res => {
        if (res.cxajaxrc == 0) {
          this.newForm.reason = res.returnvalue.reason
          this.starBook()
        }
      })
    },
    async starBook() {
      this.loading = true
      let body = this.items.post
      body.reason = this.newForm.reason
      const res = await this.$http.post(this.items.url, body)
      if (res.cxajaxrc != 0) {
        this.loading = false
        return
      }
      this.$message.success('评论成功')
      this.loading = false
      this.$emit('reason-success')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.newForm = {}
      this.ruleForm = {}
      this.$emit('reason-close')
    },
    validateReason(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入评论内容'))
      } else if (value.length < 50) {
        return callback(new Error('评论内容不能少于50字'))
      } else {
        callback()
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
  background: #e68422;
  padding: 15px;
  .el-dialog__title,
  .el-dialog__close {
    color: #fff;
  }
}
/deep/ .el-form-item__label,
/deep/ .el-textarea__inner {
  resize: none;
  font-size: 18px;
  border-radius: 0;
}
.buttons {
  text-align: right;
  .el-button {
    border-radius: 0;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reason.vue